import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const profileRoutes = [
    {
        path: '/profile',
        component: React.lazy(() => import('./ProfilePage')),
        auth: authRoles.guest,
    },
]

export default profileRoutes
